
import React from "react";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import NewsCard from "./NewsCard";
import { Button } from "@/components/ui/button";
import { ArrowLeft, ArrowRight } from "lucide-react";
import useEmblaCarousel from "embla-carousel-react";

const NewsCarousel = () => {
  console.log("[NewsCarousel] Rendering NewsCarousel component");
  const [emblaRef, emblaApi] = useEmblaCarousel({ 
    align: "start",
    loop: true
  });

  const scrollPrev = React.useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = React.useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  const { data: articles, isLoading, error } = useQuery({
    queryKey: ["published-articles"],
    queryFn: async () => {
      console.log("[NewsCarousel] Fetching published articles from Supabase");
      const { data, error } = await supabase
        .from("articles")
        .select("*")
        .eq('status', 'published')
        .order("created_at", { ascending: false })
        .limit(8);
      
      if (error) {
        console.error("[NewsCarousel] Error fetching articles:", error);
        throw error;
      }
      
      console.log("[NewsCarousel] Articles fetched successfully:", data);
      return data;
    },
  });

  if (isLoading) {
    console.log("[NewsCarousel] Loading articles...");
    return <div>Loading...</div>;
  }

  if (error) {
    console.error("[NewsCarousel] Error in component:", error);
    return <div>Error loading articles</div>;
  }

  console.log("[NewsCarousel] Rendering articles carousel");
  return (
    <div className="relative">
      <div className="overflow-hidden" ref={emblaRef}>
        <div className="flex">
          {articles?.map((article) => (
            <div key={article.id} className="flex-[0_0_100%] min-w-0 md:flex-[0_0_50%] lg:flex-[0_0_25%] pl-4">
              <NewsCard
                id={article.id}
                title={article.title}
                description={article.description}
                imageUrl={article.image_url}
              />
            </div>
          ))}
        </div>
      </div>
      
      <div className="flex justify-center gap-4 mt-6">
        <Button
          variant="outline"
          size="icon"
          className="rounded-full"
          onClick={scrollPrev}
        >
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <Button
          variant="outline"
          size="icon"
          className="rounded-full"
          onClick={scrollNext}
        >
          <ArrowRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default NewsCarousel;
